// extracted by mini-css-extract-plugin
export default {"Coffee":"Coffee_Coffee__zcrhp","CoffeeLogo":"Coffee_CoffeeLogo__zriqq"};